"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchCancelTriggerOrder = exports.cancelTriggerOrder = void 0;
const const_1 = require("./../../../component/const");
const TriggersApi_1 = require("../../../apis/TriggersApi");
const rxjs_1 = require("rxjs");
/**取消条件单 */
function cancelTriggerOrder(params) {
    return (0, TriggersApi_1.deleteTriggerOrder)(params);
}
exports.cancelTriggerOrder = cancelTriggerOrder;
function isTriggerOrders(list) {
    if (!list.length) {
        return false;
    }
    return !!list[0]["type"];
}
/**批量取消条件单 */
function batchCancelTriggerOrder(_params) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = isTriggerOrders(_params)
            ? _params.map((it) => ({
                symbol: it.symbol,
                accountType: const_1.FutureAccountType,
                triggerId: it.trigger_id,
            }))
            : _params;
        try {
            const results = yield Promise.allSettled(params.map((p) => (0, rxjs_1.firstValueFrom)((0, TriggersApi_1.deleteTriggerOrder)(p))));
            const success = [];
            const errors = [];
            results.forEach(({ status }, index) => {
                if (status === "fulfilled") {
                    success.push(params[index]);
                }
                else {
                    errors.push(params[index]);
                }
            });
            return { success, errors };
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    });
}
exports.batchCancelTriggerOrder = batchCancelTriggerOrder;
